import Bar from './Bar.js'
import DimensionLine from './DimensionLine.js'
import Donut from './Donut.js'
import DoubleLine from './DoubleLine.js'
import MeasuresLine from './MeasuresLine.js'
import Pie from './Pie.js'
import Radar from './Radar.js'
import StackedBar from './StackedBar.js'
import SunBurst from './SunBurst.js'
import Counter from './Counter.js'
import DataTable from './DataTable.js'
import DataTableHierarchical from './DataTableHierarchical.js'
import ScatterPlot from './ScatterPlot.js'
import TreeMap from './TreeMap.js'
import Pyramid from './Pyramid.js'
import HorizontalBar from './HorizontalBar'
import BarAndLine from './BarAndLine'
import CloudTag from './CloudTag'
import Gauge from './Gauge'
import DimensionRadar from './DimensionRadar'
import DimensionMultipleGraph from './DimensionMultipleGraph'
import GroupedBar from './GroupedBar'
import HorizontalGroupedBar from './HorizontalGroupedBar'

const all = [
  Bar,
  DimensionLine,
  Donut,
  DoubleLine,
  MeasuresLine,
  Pie,
  Radar,
  StackedBar,
  SunBurst,
  Counter,
  DataTable,
  DataTableHierarchical,
  ScatterPlot,
  TreeMap,
  Pyramid,
  HorizontalBar,
  BarAndLine,
  CloudTag,
  Gauge,
  DimensionRadar,
  DimensionMultipleGraph,
  GroupedBar,
  HorizontalGroupedBar
]

class RegistryClass {
  constructor () {
    this.graphs = {}
    all.forEach(graph => this.register(graph))
  }

  register (graph) {
    this.graphs[graph.id] = graph
  }

  unregister (id) {
    delete this.graphs[id]
  }

  get (id) {
    if (typeof this.graphs[id] !== 'undefined') {
      return this.graphs[id]
    }
    return null
  }

  asArray () {
    return Object.keys(this.graphs).map(k => this.graphs[k]).filter(g => g).sort((a, b) => {
      return a.label.localeCompare(b.label)
    })
  }
}

const Registry = new RegistryClass()

export {
  Bar,
  DimensionLine,
  Donut,
  DoubleLine,
  MeasuresLine,
  Pie,
  Radar,
  StackedBar,
  SunBurst,
  Counter,
  DataTable,
  DataTableHierarchical,
  ScatterPlot,
  TreeMap,
  Pyramid,
  HorizontalBar,
  BarAndLine,
  CloudTag,
  Gauge,
  DimensionRadar,
  DimensionMultipleGraph,
  GroupedBar,
  HorizontalGroupedBar,
  Registry,
  all
}



// WEBPACK FOOTER //
// ./node_modules/macarons-graphs-front/src/graph/index.js